import { siteInfo } from '@/mocks/site';
import { faqItems } from '@/mocks/faq';
import SEO from '@/components/feature/SEO';
import { OrganizationSchema, WebsiteSchema, WebPageSchema } from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const faqSchemaData = {
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEO
        title="高义白洁——品格高尚、志节纯洁的人生追求"
        description={siteInfo.description}
        keywords="高义白洁,高义白洁的意思,高义白洁典故,高义白洁出处,君子品格,高洁志节,传统美德"
        canonicalPath="/"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20calligraphy%20of%20characters%20meaning%20noble%20character%20on%20aged%20paper%20with%20traditional%20scholarly%20elements%20ink%20brush%20and%20seal%20stamp%20warm%20golden%20background%20serene%20cultural%20atmosphere&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <OrganizationSchema />
      <WebsiteSchema />
      <WebPageSchema
        pageUrl="/"
        pageTitle="高义白洁——品格高尚、志节纯洁的人生追求"
        pageDescription={siteInfo.description}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          ...faqSchemaData,
        }, null, 2) }}
      />

      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <CategoriesSection />
          <FeaturedArticles />
          <LatestArticles />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}